import {Grid} from "@mui/material";
import {useSelector} from "react-redux";
// TODO: Warning - this import bypasses the module mechanism and should be removed.
import {canDisplayNewsManagerForm} from "../../../modules/news/constants";
import SettingsSelect from "../../settings-select";
import {
  canDisplayAppSettingsForm,
  canDisplayNodesSettingsForm,
  canDisplayUsersSettingsForm,
  canGetQueryLog,
  canManageAppDashboards,
  canManageFilters,
  canManagePersonalCustomPages,
  canSetMachineToMachinePassword
} from "../../../utils/permissions";

const SettingsSelectButton = ({user, nodes, viewMode, onNavigate}) => {
  const moduleConfigs = useSelector(state => state.moduleConfigs);

  if (
    canDisplayAppSettingsForm(user) ||
    canDisplayNodesSettingsForm(user) ||
    canDisplayUsersSettingsForm(user) ||
    (moduleConfigs.modules.includes("custom-page") && canManagePersonalCustomPages(user)) ||
    (moduleConfigs.modules.includes("dashboard") && canManageAppDashboards(user)) ||
    (moduleConfigs.modules.includes("dashboard") && canManageFilters(user)) ||
    canSetMachineToMachinePassword(user) ||
    canGetQueryLog(user) ||
    canDisplayNewsManagerForm(user)
  ) {
    return (
      <Grid className="admin-settings-btn">
        <SettingsSelect nodes={nodes} viewMode={viewMode} onNavigate={onNavigate} />
      </Grid>
    );
  } else {
    return null;
  }
};

export default SettingsSelectButton;
